// import axios, { AxiosError, AxiosRequestConfig } from "axios";
// import type { ApiEnvelope, BusinessEvent, Campaign, NamedGroup, NotificationLog, NotificationRule, NotificationTemplate, QueueMetrics } from "./types";

// // const notificationBase = process.env.REACT_APP_NOTIFICATION_API_URL || "http://localhost:3001/api";
// // const auditBase = process.env.REACT_APP_AUDIT_API_URL || "http://localhost:5009/api/v1";

// const notificationBase = process.env.REACT_APP_NOTIFICATION_API_URL || "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/notification/api";
// const auditBase = process.env.REACT_APP_AUDIT_API_URL || "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/auditlog/api/v1";
// const notificationClient = axios.create({ baseURL: notificationBase });
// const auditClient = axios.create({ baseURL: auditBase });

// // `any` here intentionally keeps this interceptor compatible with both Axios
// // 0.x (AxiosRequestConfig) and Axios 1.x (InternalAxiosRequestConfig).
// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// const addSessionHeaders = (config: any) => {
//   const token = sessionStorage.getItem("accessToken");
//   const rawUser = sessionStorage.getItem("backendResponse") || sessionStorage.getItem("BackendResponse");
//   let userId = "admin-user";
//   let userRole = "admin";
//   if (rawUser) {
//     try {
//       const user = JSON.parse(rawUser) as { entraObjectId?: string; id?: string; _id?: string; roleAssignments?: Array<{ roleId?: { key?: string } }> };
//       userId = user.entraObjectId || user.id || user._id || userId;
//       userRole = user.roleAssignments?.[0]?.roleId?.key || userRole;
//     } catch { /* optional identity header only */ }
//   }
//   config.headers = {
//     ...(config.headers || {}),
//     ...(token ? { Authorization: `Bearer ${token}` } : {}),
//     "X-User-Id": userId,
//     "X-User-Role": userRole,
//   };
//   return config;
// };

// notificationClient.interceptors.request.use(addSessionHeaders);
// auditClient.interceptors.request.use(addSessionHeaders);

// const unwrap = <T,>(body: ApiEnvelope<T> | T): T => {
//   if (body !== null && typeof body === "object" && !Array.isArray(body) && "data" in body) return (body as ApiEnvelope<T>).data;
//   return body as T;
// };
// const request = async <T,>(config: AxiosRequestConfig): Promise<T> => unwrap<T>((await notificationClient.request<ApiEnvelope<T> | T>(config)).data);
// const auditRequest = async <T,>(config: AxiosRequestConfig): Promise<T> => unwrap<T>((await auditClient.request<ApiEnvelope<T> | T>(config)).data);

// export const getApiError = (error: unknown): string => {
//   if (axios.isAxiosError(error)) {
//     const e = error as AxiosError<{ message?: string; error?: string }>;
//     return e.response?.data?.message || e.response?.data?.error || e.message || "Request failed";
//   }
//   return error instanceof Error ? error.message : "Request failed";
// };

// export const notificationApi = {
//   events: {
//     list: () => request<BusinessEvent[]>({ method: "GET", url: "/admin/business-events" }),
//     get: (id: string) => request<BusinessEvent>({ method: "GET", url: `/admin/business-events/${id}` }),
//     create: (body: Omit<BusinessEvent, "_id">) => request<BusinessEvent>({ method: "POST", url: "/admin/business-events", data: body }),
//     update: (id: string, body: Partial<BusinessEvent>) => request<BusinessEvent>({ method: "PUT", url: `/admin/business-events/${id}`, data: body }),
//     remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/business-events/${id}` }),
//     toggle: (id: string) => request<BusinessEvent>({ method: "PATCH", url: `/admin/business-events/${id}/toggle` }),
//   },
//   templates: {
//     list: () => request<NotificationTemplate[]>({ method: "GET", url: "/admin/templates" }),
//     get: (id: string) => request<NotificationTemplate>({ method: "GET", url: `/admin/templates/${id}` }),
//     create: (body: NotificationTemplate) => request<NotificationTemplate>({ method: "POST", url: "/admin/templates", data: body }),
//     update: (id: string, body: NotificationTemplate) => request<NotificationTemplate>({ method: "PUT", url: `/admin/templates/${id}`, data: body }),
//     remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/templates/${id}` }),
//     variables: (eventCode: string, showAll = false) => request<{ variables: string[]; grouped?: Record<string, string[]>; total?: number }>({ method: "GET", url: `/variables/event/${encodeURIComponent(eventCode)}`, params: { showAll } }),
//   },
//   rules: {
//     list: () => request<NotificationRule[]>({ method: "GET", url: "/admin/notification-rules" }),
//     create: (body: Partial<NotificationRule>) => request<NotificationRule>({ method: "POST", url: "/admin/notification-rules", data: body }),
//     update: (id: string, body: Partial<NotificationRule>) => request<NotificationRule>({ method: "PUT", url: `/admin/notification-rules/${id}`, data: body }),
//     remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/notification-rules/${id}` }),
//     toggle: (id: string) => request<NotificationRule>({ method: "PATCH", url: `/admin/notification-rules/${id}/toggle` }),
//   },
//   recipientGroups: {
//     list: () => request<NamedGroup[]>({ method: "GET", url: "/admin/recipient-groups" }),
//     create: (body: Partial<NamedGroup>) => request<NamedGroup>({ method: "POST", url: "/admin/recipient-groups", data: body }),
//     update: (id: string, body: Partial<NamedGroup>) => request<NamedGroup>({ method: "PUT", url: `/admin/recipient-groups/${id}`, data: body }),
//     remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/recipient-groups/${id}` }),
//   },
//   templateGroups: {
//     list: () => request<NamedGroup[]>({ method: "GET", url: "/admin/template-groups" }),
//     create: (body: Partial<NamedGroup>) => request<NamedGroup>({ method: "POST", url: "/admin/template-groups", data: body }),
//     update: (id: string, body: Partial<NamedGroup>) => request<NamedGroup>({ method: "PUT", url: `/admin/template-groups/${id}`, data: body }),
//     remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/template-groups/${id}` }),
//   },
//   campaigns: {
//     list: () => request<Campaign[]>({ method: "GET", url: "/admin/campaigns" }),
//     stats: () => request<Array<{ _id: string; count: number }>>({ method: "GET", url: "/admin/campaigns/stats" }),
//     cancel: (id: string) => request<void>({ method: "POST", url: `/admin/campaigns/${id}/cancel` }),
//   },
//   logs: {
//     list: () => request<NotificationLog[]>({ method: "GET", url: "/admin/logs" }),
//     recent: () => auditRequest<NotificationLog[]>({ method: "GET", url: "/logs", params: { limit: 20 } }),
//     retry: (id: string) => request<void>({ method: "POST", url: `/admin/logs/${id}/retry` }),
//   },
//   queue: () => request<QueueMetrics | { data: QueueMetrics }>({ method: "GET", url: "/admin/metrics/queue" }),
//   test: (body: Record<string, unknown>) => request<unknown>({ method: "POST", url: "/testing/execute", data: body }),
// };


// src\components\Super Admin\Lead Management\notificationApi.ts
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import type {
  ApiEnvelope,
  BusinessEvent,
  Campaign,
  CampaignConfig,
  NamedGroup,
  NotificationLog,
  NotificationRule,
  NotificationTemplate,
  QueueMetrics,
  VariableResponse,
} from "./types";

// const notificationBase = "http://localhost:3001/api";
// const auditBase = process.env.REACT_APP_AUDIT_API_URL || "http://localhost:4002/api/v1";

const notificationBase = process.env.REACT_APP_NOTIFICATION_API_URL || "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/notification/api";
const auditBase = process.env.REACT_APP_AUDIT_API_URL || "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/auditlog/api/v1";
const notificationClient = axios.create({ baseURL: notificationBase });
const auditClient = axios.create({ baseURL: auditBase });

// `any` here intentionally keeps this interceptor compatible with both Axios
// 0.x (AxiosRequestConfig) and Axios 1.x (InternalAxiosRequestConfig).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addSessionHeaders = (config: any) => {
  const token = sessionStorage.getItem("accessToken");
  const rawUser = sessionStorage.getItem("backendResponse") || sessionStorage.getItem("BackendResponse");
  let userId = "admin-user";
  let userRole = "admin";
  if (rawUser) {
    try {
      const user = JSON.parse(rawUser) as { entraObjectId?: string; id?: string; _id?: string; roleAssignments?: Array<{ roleId?: { key?: string } }> };
      userId = user.entraObjectId || user.id || user._id || userId;
      userRole = user.roleAssignments?.[0]?.roleId?.key || userRole;
    } catch { /* optional identity header only */ }
  }
  config.headers = {
    ...(config.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "X-User-Id": userId,
    "X-User-Role": userRole,
  };
  return config;
};

notificationClient.interceptors.request.use(addSessionHeaders);
auditClient.interceptors.request.use(addSessionHeaders);

const unwrap = <T,>(body: ApiEnvelope<T> | T): T => {
  if (body !== null && typeof body === "object" && !Array.isArray(body) && "data" in body) return (body as ApiEnvelope<T>).data;
  return body as T;
};
const request = async <T,>(config: AxiosRequestConfig): Promise<T> => unwrap<T>((await notificationClient.request<ApiEnvelope<T> | T>(config)).data);
const auditRequest = async <T,>(config: AxiosRequestConfig): Promise<T> => unwrap<T>((await auditClient.request<ApiEnvelope<T> | T>(config)).data);

export const getApiError = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const e = error as AxiosError<{ message?: string; error?: string }>;
    return e.response?.data?.message || e.response?.data?.error || e.message || "Request failed";
  }
  return error instanceof Error ? error.message : "Request failed";
};

export const notificationApi = {
  events: {
    list: () => request<BusinessEvent[]>({ method: "GET", url: "/admin/business-events" }),
    get: (id: string) => request<BusinessEvent>({ method: "GET", url: `/admin/business-events/${id}` }),
    create: (body: Omit<BusinessEvent, "_id">) => request<BusinessEvent>({ method: "POST", url: "/admin/business-events", data: body }),
    update: (id: string, body: Partial<BusinessEvent>) => request<BusinessEvent>({ method: "PUT", url: `/admin/business-events/${id}`, data: body }),
    remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/business-events/${id}` }),
    toggle: (id: string) => request<BusinessEvent>({ method: "PATCH", url: `/admin/business-events/${id}/toggle` }),
  },
  templates: {
    list: () => request<NotificationTemplate[]>({ method: "GET", url: "/admin/templates" }),
    get: (id: string) => request<NotificationTemplate>({ method: "GET", url: `/admin/templates/${id}` }),
    create: (body: NotificationTemplate) => request<NotificationTemplate>({ method: "POST", url: "/admin/templates", data: body }),
    update: (id: string, body: Partial<NotificationTemplate>) => request<NotificationTemplate>({ method: "PUT", url: `/admin/templates/${id}`, data: body }),
    remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/templates/${id}` }),
    variables: (eventCode: string, showAll = false) => request<VariableResponse>({
      method: "GET",
      url: `/variables/event/${encodeURIComponent(eventCode)}`,
      params: { showAll }
    }),
    preview: (id: string, data: Record<string, unknown>) => request<{ rendered: string }>({
      method: "POST",
      url: `/admin/templates/${id}/preview`,
      data
    }),
  },
  rules: {
    list: () => request<NotificationRule[]>({ method: "GET", url: "/admin/notification-rules" }),
    get: (id: string) => request<NotificationRule>({ method: "GET", url: `/admin/notification-rules/${id}` }),
    create: (body: Partial<NotificationRule>) => request<NotificationRule>({ method: "POST", url: "/admin/notification-rules", data: body }),
    update: (id: string, body: Partial<NotificationRule>) => request<NotificationRule>({ method: "PUT", url: `/admin/notification-rules/${id}`, data: body }),
    remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/notification-rules/${id}` }),
    toggle: (id: string) => request<NotificationRule>({ method: "PATCH", url: `/admin/notification-rules/${id}/toggle` }),
  },
  recipientGroups: {
    list: () => request<NamedGroup[]>({ method: "GET", url: "/admin/recipient-groups" }),
    get: (id: string) => request<NamedGroup>({ method: "GET", url: `/admin/recipient-groups/${id}` }),
    create: (body: Partial<NamedGroup>) => request<NamedGroup>({ method: "POST", url: "/admin/recipient-groups", data: body }),
    update: (id: string, body: Partial<NamedGroup>) => request<NamedGroup>({ method: "PUT", url: `/admin/recipient-groups/${id}`, data: body }),
    remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/recipient-groups/${id}` }),
  },
  templateGroups: {
    list: () => request<NamedGroup[]>({ method: "GET", url: "/admin/template-groups" }),
    get: (id: string) => request<NamedGroup>({ method: "GET", url: `/admin/template-groups/${id}` }),
    create: (body: Partial<NamedGroup>) => request<NamedGroup>({ method: "POST", url: "/admin/template-groups", data: body }),
    update: (id: string, body: Partial<NamedGroup>) => request<NamedGroup>({ method: "PUT", url: `/admin/template-groups/${id}`, data: body }),
    remove: (id: string) => request<void>({ method: "DELETE", url: `/admin/template-groups/${id}` }),
  },
  campaigns: {
    list: () => request<Campaign[]>({ method: "GET", url: "/admin/campaigns" }),
    get: (id: string) => request<Campaign>({ method: "GET", url: `/admin/campaigns/${id}` }),
    stats: () => request<Array<{ _id: string; count: number }>>({ method: "GET", url: "/admin/campaigns/stats" }),
    cancel: (id: string) => request<void>({ method: "POST", url: `/admin/campaigns/${id}/cancel` }),
  },
  logs: {
    list: () => request<NotificationLog[]>({ method: "GET", url: "/admin/logs" }),
    recent: () => auditRequest<NotificationLog[]>({ method: "GET", url: "/logs", params: { limit: 20 } }),
    retry: (id: string) => request<void>({ method: "POST", url: `/admin/logs/${id}/retry` }),
  },
  queue: () => request<QueueMetrics | { data: QueueMetrics }>({ method: "GET", url: "/admin/metrics/queue" }),
  test: (body: Record<string, unknown>) => request<unknown>({ method: "POST", url: "/testing/execute", data: body }),
  discovery: {
    services: () => request<string[]>({ method: "GET", url: "/admin/discovery/services" }),
    modules: (service: string) => request<string[]>({
      method: "GET",
      url: `/admin/discovery/modules?service=${encodeURIComponent(service)}`
    }),
    actions: (service?: string) => {
      let url = "/admin/discovery/actions";
      if (service) {
        url += `?service=${encodeURIComponent(service)}`;
      }
      return request<string[]>({ method: "GET", url });
    },
    statuses: () => request<string[]>({ method: "GET", url: "/admin/discovery/statuses" }),
  },
};